import React from 'react';
import Input from '../../components/Input';
import { ExpandArrowIcon } from '../../icons';
export var MuiSelect = {
    input: React.createElement(Input, null),
    IconComponent: ExpandArrowIcon,
    MenuProps: {
        // forces the menu below the input
        anchorOrigin: {
            horizontal: 'right',
            vertical: 'bottom',
        },
        transformOrigin: {
            horizontal: 'right',
            vertical: 'top',
        },
        MenuListProps: {
            disablePadding: true,
        },
        PaperProps: {
            square: true,
            style: {
                transform: 'translate(0, -2px)',
            },
        },
    },
};
//# sourceMappingURL=MuiSelect.js.map